/**
 * Pure PT/BR helpers (vitest-covered). Portugal is always the safe default;
 * sensitive operations fail closed when the market is not Portugal.
 */
export type MarketCode = "pt" | "br";

/** Same convention as the database (COALESCE(market,'pt')). Unknown values fail closed to null. */
export function resolveCompanyMarket(raw: string | null | undefined): MarketCode | null {
  if (raw === null || raw === undefined || raw === "") return "pt";
  const v = String(raw).toLowerCase().trim();
  return v === "pt" || v === "br" ? v : null;
}

/** PT keeps the legacy key so existing carts are never lost. */
export function cartStorageKey(market: MarketCode): string {
  return market === "pt" ? "hexatech_cart" : `hexatech_cart_${market}`;
}

/** `user_carts` has no market column yet: only Portugal syncs to the server. */
export function shouldSyncCartToServer(market: MarketCode): boolean {
  return market === "pt";
}

/** TOConline is the Portuguese fiscal system: only PT documents may be issued there. */
export function canUseTOConline(rawCompanyMarket: string | null | undefined): boolean {
  return resolveCompanyMarket(rawCompanyMarket) === "pt";
}
